/* KitKraft notebook-style code blocks
   Wraps every <pre><code> inside an article body with a header bar (language label +
   copy button) and colour-codes common C/C++/Arduino syntax. Runs sitewide on every
   blog article template — new posts with a fenced code block pick this up automatically,
   no per-article markup needed. Defensive: no-ops if there's nothing to do. */
(function () {
  "use strict";

  var blocks = document.querySelectorAll(".article-template_content pre > code");
  if (!blocks.length) return;

  var TOKEN_RE = new RegExp(
    "(//[^\\n]*)" +                                   // 1 line comment
    "|(/\\*[\\s\\S]*?\\*/)" +                          // 2 block comment
    "|(\"(?:[^\"\\\\\\n]|\\\\.)*\"|'(?:[^'\\\\\\n]|\\\\.)*')" + // 3 string
    "|(^[ \\t]*#[ \\t]*\\w+[^\\n]*)" +                 // 4 preprocessor line
    "|(\\b(?:0x[0-9a-fA-F]+|\\d+\\.?\\d*[a-zA-Z]?)\\b)" + // 5 number
    "|(\\b(?:void|int|char|float|double|long|short|unsigned|signed|byte|boolean|bool|String|" +
      "const|static|volatile|if|else|for|while|do|return|break|continue|switch|case|default|" +
      "struct|class|public|private|protected|new|delete|sizeof|typedef|enum|union|true|false|" +
      "null|NULL|include|define)\\b)" +                // 6 keyword
    "|([A-Za-z_]\\w*)(?=\\s*\\()",                     // 7 function call
    "gm"
  );

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function highlight(rawText) {
    var escaped = escapeHtml(rawText);
    return escaped.replace(TOKEN_RE, function (m, com, block, str, pre, num, kw, fn) {
      if (com !== undefined) return '<span class="tok-com">' + com + "</span>";
      if (block !== undefined) return '<span class="tok-com">' + block + "</span>";
      if (str !== undefined) return '<span class="tok-str">' + str + "</span>";
      if (pre !== undefined) return '<span class="tok-pre">' + pre + "</span>";
      if (num !== undefined) return '<span class="tok-num">' + num + "</span>";
      if (kw !== undefined) return '<span class="tok-kw">' + kw + "</span>";
      if (fn !== undefined) return '<span class="tok-fn">' + fn + "</span>";
      return m;
    });
  }

  function detectLang(text) {
    if (/void\s+setup\s*\(/.test(text) && /void\s+loop\s*\(/.test(text)) return "Arduino";
    if (/#include/.test(text)) return "C++";
    if (/^\s*(def |import |from .+ import|print\()/m.test(text)) return "Python";
    return "Code";
  }

  var copyIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/>' +
    '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var checkIcon =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  blocks.forEach(function (code) {
    var pre = code.parentElement;
    if (!pre || pre.closest(".kk-codeblock")) return;

    var rawText = code.textContent;
    code.innerHTML = highlight(rawText);

    var wrapper = document.createElement("div");
    wrapper.className = "kk-codeblock";

    var bar = document.createElement("div");
    bar.className = "kk-codeblock__bar";

    var lang = document.createElement("span");
    lang.className = "kk-codeblock__lang";
    lang.textContent = detectLang(rawText);

    var copyBtn = document.createElement("button");
    copyBtn.type = "button";
    copyBtn.className = "kk-codeblock__copy";
    copyBtn.innerHTML = copyIcon + '<span class="kk-codeblock__copy-label">Copy</span>';
    copyBtn.addEventListener("click", function () {
      var done = function () {
        copyBtn.classList.add("is-copied");
        copyBtn.innerHTML = checkIcon + '<span class="kk-codeblock__copy-label">Copied!</span>';
        setTimeout(function () {
          copyBtn.classList.remove("is-copied");
          copyBtn.innerHTML = copyIcon + '<span class="kk-codeblock__copy-label">Copy</span>';
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(rawText).then(done, done);
      } else {
        var ta = document.createElement("textarea");
        ta.value = rawText;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand("copy"); } catch (e) {}
        document.body.removeChild(ta);
        done();
      }
    });

    bar.appendChild(lang);
    bar.appendChild(copyBtn);

    pre.parentNode.insertBefore(wrapper, pre);
    wrapper.appendChild(bar);
    wrapper.appendChild(pre);
  });
})();
